import { getWithToken } from './http-client';

export default {
  async obtenerPaquetesOfertas(datos, token) {
    return getWithToken(`${process.env.RAZZLE_API_OFFERS}/package-offers/${datos}/information`, token)
      .then((res) => res)
      .catch((error) => {
        console.error(error);
        return null;
      });

  },
};
